import { render, staticRenderFns } from "./TherapistDashScheduleTable.vue?vue&type=template&id=009611b3&scoped=true"
import script from "./TherapistDashScheduleTable.vue?vue&type=script&lang=js"
export * from "./TherapistDashScheduleTable.vue?vue&type=script&lang=js"
import style0 from "./TherapistDashScheduleTable.vue?vue&type=style&index=0&id=009611b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009611b3",
  null
  
)

export default component.exports